// extracted by mini-css-extract-plugin
export var animationContainer = "_im-0";
export var asteriskIcon = "_im-8";
export var conversationLeftSection = "_im-4";
export var conversationListItem = "_im-3";
export var conversationMiddleSection = "_im-5";
export var conversationRightSection = "_im-6";
export var detailsContent = "_im-1";
export var listContainer = "_im-7";
export var modalContent = "_im-2";